import { ref, computed } from 'vue'
import { useUtilStore } from "~/store/util"
import type {PublicConfig} from "~/utils/types/config"

export const useExitModal = () => {
  const utils = useUtilStore()
  
  const exitModal = ref<ModalModel>({
    show: false,
    loading: false,
  });

  const shouldShowExitModal = computed(() => {
    return !utils.isSummaryPage && !utils.isDirectPage
  })

  const showExitModal = () => {
    if (shouldShowExitModal.value) {
      exitModal.value.show = true
    }
  }

  const handleLogoClick = (event: Event) => {
    if (shouldShowExitModal.value) {
      event.preventDefault()
      showExitModal()
    }
  }

  const setupBrowserBackHandler = () => {
    if (shouldShowExitModal.value) {
      window.history.pushState({ page: 1 }, "", "");
      window.onpopstate = function() {
        //This only works when there's user interaction on chrome (a click on the window itself) 
        //and safari (interaction on the site, like a button)
        exitModal.value.show = true
      };
    }
  }

  const config: PublicConfig = useRuntimeConfig().public as PublicConfig
  const homepageUrl = config.homepage_url as string || '/';

  return {
    exitModal,
    shouldShowExitModal,
    showExitModal,
    handleLogoClick,
    setupBrowserBackHandler,
    homepageUrl
  }
}